import React from 'react';
import { useTranslation } from 'react-i18next';
const MbmOOSBox = (props) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "info-box" },
        React.createElement("b", null, t('mbm.oostitle')),
        React.createElement("p", null,
            t('mbm.oostext1'),
            ' ',
            React.createElement("button", { onClick: props.onClick, className: "link-button bold" }, t('mbm.oostext2')),
            ' ',
            t('mbm.oostext3'))));
};
export default MbmOOSBox;
